module.exports = __webpack_public_path__ + "media/images/plans/plan-icon-wedding-hairmake-men-99c32b876c02be47976c396c652a13ff.png";